import styled from 'styled-components';

import ReactSelect from '@ey/canvascoreservices/ReactSelect';

export default styled(ReactSelect)`
	.react-select-container .react-select__control .react-select__multi-value {
		background: transparent;
		margin: 0;

		.react-select__multi-value__remove {
			display: none;
		}
		.react-select__multi-value__label {
			padding: 0;
			padding-top: var(--spacing-medium);
		}
	}
`;
